/* import __COLOCATED_TEMPLATE__ from './brand-phone-filter-header.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';
import { action } from '@ember/object';

interface Args {
  item: {
    text: string;
    value: string;
    componentAttrs: {
      filterState: {
        showCalling: boolean;
        showSms: boolean;
        toggleCalling: () => void;
        toggleSms: () => void;
      };
      callingLabel: string;
      smsLabel: string;
    };
  };
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

export default class BrandPhoneFilterHeader extends Component<Signature> {
  get filterState() {
    return this.args.item.componentAttrs.filterState;
  }

  @action
  toggleCalling() {
    this.filterState.toggleCalling();
  }

  @action
  toggleSms() {
    this.filterState.toggleSms();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Brands::BrandPhoneFilterHeader': typeof BrandPhoneFilterHeader;
    'new-settings/workspace/brands/brand-phone-filter-header': typeof BrandPhoneFilterHeader;
  }
}
